module.exports = __webpack_public_path__ + "img/vrsc.2d419c27.svg";